import React, { Fragment, useContext } from 'react';
import cn from 'classnames';
import {
  Context,
  toggleMainNav,
} from 'chameleon/ui-stack/ui/basic/main-nav-two-levels';

const SideBar = (props) => {
  const { children } = props;
  const [{ isOpen }, dispatch] = useContext(Context);

  return (
    <Fragment>
      <div
        id="sidebar"
        className={cn('mobile:w-full flex h-full fixed mt-25 z-50 shadow-lg', {
          'mobile:hidden': !isOpen,
        })}
      >
        {children}
      </div>
      {isOpen && (
        <div
          onClick={() => toggleMainNav(dispatch, false)}
          className="w-full h-full bg-black bg-opacity-10 absolute z-9 top-6.5"
        />
      )}
    </Fragment>
  );
};

export default SideBar;
